import React from 'react';
import { ClipboardCheckIcon, ListOrderedIcon, MessagesSquareIcon, QuoteIcon, TargetIcon, TimerIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { ctaMicrocopy, plan } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const icons: Record<(typeof plan.features)[number]['icon'], LucideIcon> = {
  goal: TargetIcon,
  timer: TimerIcon,
  steps: ListOrderedIcon,
  questions: MessagesSquareIcon,
  quote: QuoteIcon,
  action: ClipboardCheckIcon
};
const numberColors = ['text-sun', 'text-coral', 'text-leaf', 'text-white'];
const tiles = ['bg-sun text-ink', 'bg-coral text-ink', 'bg-leaf text-ink', 'bg-white text-brand'];

/** "A clear plan before you walk in": how it works + what every complete meeting has */
export function SolutionSection() {
  return <section aria-labelledby="plan-title" className="bg-brand py-12 md:py-20" data-id="element-189" data-mp="kqh5swa2wh4g">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-190" data-mp="fvbpcczg3unr">
        <SectionHeading id="plan-title" tone="dark" eyebrow={plan.eyebrow} title={plan.title} sub={plan.text} data-id="element-191" data-mp="36b5mf49wxoii" />

        <ol className="mt-10 grid grid-cols-2 gap-3 md:mt-12 md:grid-cols-4 md:gap-4" data-id="element-192" data-mp="3baqjf95ivmsl">
          {plan.steps.map((step, i) => <li key={step.title} className="rounded-xl bg-brand-dark p-4 md:p-6" data-id="element-193" data-mp="3f9zd6e0kbko5" data-mpi={i}>
              <span className={`font-display text-[2.2rem] font-black leading-none md:text-[2.8rem] ${numberColors[i % numberColors.length]}`} data-id="element-194" data-mp="3kb6mwim9mtxg">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-2 font-display text-[16px] font-black tracking-tight text-white md:text-[18px]" data-id="element-195" data-mp="3u6qewtxpl8gx">{step.title}</h3>
              <p className="mt-1 text-[14px] leading-snug text-white/80 md:text-[15px]" data-id="element-196" data-mp="6vh9eohnmrac">{step.text}</p>
            </li>)}
        </ol>

        <h3 className="mt-12 text-center font-display text-[13px] font-black tracking-[0.14em] text-sun" data-id="element-197" data-mp="bvmxjuoptvno">{plan.featuresTitle}</h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-3" data-id="element-198" data-mp="gty7s6ixa86f">
          {plan.features.map((f, i) => {
          const Icon = icons[f.icon];
          return <li key={f.title} className="flex gap-4 rounded-xl bg-brand-dark p-5" data-id="element-199" data-mp="27zb4ylhx0q93" data-mpi={i}>
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${tiles[i % tiles.length]}`} data-id="element-200" data-mp="2mne9dqgb7tvs">
                  <Icon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-201" data-mp="2htt91rr8untf" />
                </span>
                <div data-id="element-202" data-mp="2vp5fgweri2q6">
                  <p className="font-display text-[16px] font-extrabold leading-snug text-white" data-id="element-203" data-mp="2rlzart7asjlt">{f.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/80" data-id="element-204" data-mp="35m0av6fqnn08">{f.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 flex max-w-[420px] justify-center md:mt-12" data-id="element-205" data-mp="30kks5l119sl0">
          <CtaButton microcopy={ctaMicrocopy} microTone="light" align="center" data-id="element-206" data-mp="1b9jxlloiz8lv" />
        </div>
      </div>
    </section>;
}